import { render, staticRenderFns } from "./StudentPerformanceData.vue?vue&type=template&id=0cb98634&scoped=true&"
import script from "./StudentPerformanceData.vue?vue&type=script&lang=js&"
export * from "./StudentPerformanceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb98634",
  null
  
)

export default component.exports